export default __webpack_public_path__ + "static/media/connect.23d3312c.png";